import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface ImageIconProps extends SvgIconProps {}

export const ImageIcon = (props: ImageIconProps): ReactElement => {
  return (
    <SvgIcon style={{ fontSize: '1em' }} {...props} viewBox="0 0 51.383 38.537">
      <path
        d="M46.566.5H4.817A4.817,4.817,0,0,0,0,5.317v28.9a4.817,4.817,0,0,0,4.817,4.817H46.566a4.817,4.817,0,0,0,4.817-4.817V5.317A4.817,4.817,0,0,0,46.566.5ZM4.817,3.711H46.566a1.606,1.606,0,0,1,1.606,1.606V27.132L33.25,12.21a1.606,1.606,0,0,0-2.271,0L20.071,23.118l-4.485-4.485a1.606,1.606,0,0,0-2.271,0l-10.1,10.1V5.317A1.606,1.606,0,0,1,4.817,3.711ZM46.566,35.826H4.817A1.606,1.606,0,0,1,3.211,34.22v-.941l11.24-11.24,6.893,6.893a1.606,1.606,0,0,0,1.135.47H28.9a1.606,1.606,0,0,0,0-3.211H23.145l-.8-.8,9.772-9.772L48.172,31.674V34.22A1.606,1.606,0,0,1,46.566,35.826Zm0,0"
        transform="translate(0 -0.5)"
        fill="currentColor"
      />
      <path
        d="M132.817,58.134A4.817,4.817,0,1,0,128,53.317,4.817,4.817,0,0,0,132.817,58.134Zm0-6.423a1.606,1.606,0,1,1-1.606,1.606A1.606,1.606,0,0,1,132.817,51.711Zm0,0"
        transform="translate(-115.154 -43.683)"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
